
const CryptoJS = require('crypto-js');

export class Nodes {
  static nodesOnline = [{
    "id": "node-111",
    "host": "https://node-111.basquetpass.tv/",
    "priority": 3,
    "secure_token": false,
    "isp": "aws",
    "penalty": 0,
    "ping": "SA",
    "failover": true,
    "experimental": false,
    "only_ts": false,
    "content_id": 0,
    "type": "proxy",
    "uris": []
  },
  {
    "id": "cdn-121",
    "host": "https://node-121.basquetpass.tv/gr1/",
    "priority": 5,
    "secure_token": true,
    "isp": "cdn77",
    "penalty": 0,
    "failover": true,
    "experimental": false,
    "only_ts": false,
    "content_id": 0,
    "type": "proxy",
    "uris": []
  },
  {
    "id": "cdn-101",
    "host": "https://storage.gra.cloud.ovh.net/v1/AUTH_8549ac1840b448048f7e9d07080dc0e5/gr1/",
    "priority": 6,
    "secure_token": true,
    "isp": "ovh",
    "penalty": 0,
    "failover": true,
    "experimental": false,
    "only_ts": false,
    "content_id": 0,
    "type": "proxy",
    "uris": []
  }];


  static async init(staticContentUrl) {

    // Refrescamos ahora y cada 5 minutos
    Nodes.refreshNodes(staticContentUrl);
    setInterval(() => {
      Nodes.refreshNodes(staticContentUrl);
    }, 300000);

    // Cada 30 segundos reducir penalización
    setInterval(() => {
      Nodes.decreasePenaltyAll();
    }, 5000);
  }

  /**
  * Comprueba si la URL pasada es un nodo
  *
  * @param {string} url 
  * @param {function} callback
  */
  static async checkNode(node) {

    try {
      var status = await fetch(node.host + 'status.json?' + Math.random());
      var json = await status.json();
      if (json.status == 1) return true;
    } catch (e) {
      return false;
    }
  }

  static async fetchUrl(url) {

    // Intentamos 5 veces descargar el archivo
    for (var i = 0; i < 5; i++) {

      var nodeurl = await Nodes.prepareUrl(url);

      var ret;
      try {
        // Ponemos fetch con timeout de 2 segundos
        ret = await fetch(nodeurl.url, { timeout: 2000 });
        if (ret.status == 200) {
          Nodes.decreasePenalty(nodeurl.node.id);
          return ret;
        } else {
          // Le sumamos penalización
          Nodes.increasePenalty(nodeurl.node.id);
        }
      } catch (e) {
        Nodes.increasePenalty(nodeurl.node.id);
      }

      // Esperamos 1 segundo antes de volver a intentarlo
      await new Promise(r => setTimeout(r, 1000));

    }

    return false;

  }

  static async prepareUrl(uri, content_id = 0) {

    content_id = parseInt(content_id);

    // Sacamos el content_id de la uri, ej: 15939/hls/stream_360p.m3u8 -> 15939    
    if (content_id == 0) {
      var pos = uri.indexOf('/hls/');
      if (pos > -1) {
        content_id = parseInt(uri.substr(0, pos));
      }
    }

    // Quitamos dominio y parámetros
    uri = Nodes.getURIfromURL(uri);

    // Si es el master, garantizamos su carga
    if (uri.indexOf('stream.m3u8') > -1) {

      var node = await Nodes.searchFileInNodes(uri, content_id);

      // Añadimos la uri al nodo si no la tiene
      if (node.uris.indexOf(uri) == -1) {
        node.uris.push(uri);
      }

      if (node.type == 'dynamic-cdn' || (node.isp && node.isp == 'cdn77')) {
        return {
          node: node,
          url: Nodes.secureCDN77(uri, node)
        };
      } else {
        return {
          node: node,
          url: Nodes.secureOVH(uri, node)
        }
      }

    }


    // Vamos a ordenar los nodos por prioridad de mayor a menor, restando la penalización
    Nodes.nodesOnline.sort(function (a, b) {
      return (b.priority - b.penalty) - (a.priority - a.penalty);
    });


    // Recorremos los nodos online
    for (var i = 0; i < Nodes.nodesOnline.length; i++) {
      // Si el nodo tiene content_id, es diferente a 0 y no es el que buscamos, saltamos
      if (Nodes.nodesOnline[i].content_id && Nodes.nodesOnline[i].content_id != content_id) {
        continue;
      }

      // Añadimos la uri al nodo si no la tiene
      if (Nodes.nodesOnline[i].uris.indexOf(uri) == -1) {
        Nodes.nodesOnline[i].uris.push(uri);
      }

      if (Nodes.nodesOnline[i].type == 'dynamic-cdn' || (Nodes.nodesOnline[i].isp && Nodes.nodesOnline[i].isp == 'cdn77')) {
        return {
          node: Nodes.nodesOnline[i],
          url: Nodes.secureCDN77(uri, Nodes.nodesOnline[i])
        }
      } else {
        return {
          node: Nodes.nodesOnline[i],
          url: Nodes.secureOVH(uri, Nodes.nodesOnline[i])
        }
      }

    }


    return false;
  }

  /**
 * Busca el archivo en los nodos. Si no lo encuentra, devuelve false
 *
 * @param {*} uri 
 */
  static async searchFileInNodes(uri, content_id = 0) {

    content_id = parseInt(content_id);
    uri = Nodes.getURIfromURL(uri);

    // Si no tenemos nodos online, devolvemos false
    if (Nodes.nodesOnline.length == 0) {
      return false;
    }


    // Vamos a buscar en los nodos pero respetando el orden de prioridad y ping
    Nodes.nodesOnline.sort(function (a, b) {
      if (a.priority == b.priority) {
        return a.ping - b.ping;
      } else {
        return b.priority - a.priority;
      }
    });


    // Recorremos los nodos online
    for (var i = 0; i < Nodes.nodesOnline.length; i++) {
      // Si el nodo tiene content_id, es diferente a 0 y no es el que buscamos, saltamos
      if (Nodes.nodesOnline[i].content_id && Nodes.nodesOnline[i].content_id != content_id) {
        continue;
      }

      if (Nodes.nodesOnline[i].type == 'dynamic-cdn' || (Nodes.nodesOnline[i].isp && Nodes.nodesOnline[i].isp == 'cdn77')) {
        var url = Nodes.secureCDN77(uri, Nodes.nodesOnline[i]);
      } else {
        var url = Nodes.secureOVH(uri, Nodes.nodesOnline[i]);
      }

      // Comprobamos si el archivo existe
      var ret;
      try {
        ret = await fetch(url);
        if (ret.status == 200) {
          return Nodes.nodesOnline[i];
        } else {
          // Le sumamos penalización
          Nodes.increasePenalty(Nodes.nodesOnline[i].id, 10);
        }
      } catch (e) {
        Nodes.increasePenalty(Nodes.nodesOnline[i].id, 10);
      }
    }
  }

  static increasePenalty(id, amount = 2) {
    for (var i = 0; i < Nodes.nodesOnline.length; i++) {
      if (Nodes.nodesOnline[i].id == id) {
        if (Nodes.nodesOnline[i].penalty < 10) {
          Nodes.nodesOnline[i].penalty += amount;
        }
      }
    }
  }

  static decreasePenalty(id, amount = 1) {
    for (var i = 0; i < Nodes.nodesOnline.length; i++) {
      if (Nodes.nodesOnline[i].id == id) {
        if (Nodes.nodesOnline[i].penalty > 0) {
          Nodes.nodesOnline[i].penalty -= amount;
        }
      }
    }
  }

  static decreasePenaltyAll() {
    for (var i = 0; i < Nodes.nodesOnline.length; i++) {
      if (Nodes.nodesOnline[i].penalty > 0) {
        Nodes.nodesOnline[i].penalty -= 1;
      }
    }
  }

  static async refreshNodes(staticContentUrl) {


    var response;
    try {
      response = await fetch(staticContentUrl + "data/cdn/content_cdns.json?" + Math.random());
    } catch (e) {
      return;
    }

    if (response.status !== 200) {
      return;
    }
    var nodes = await response.json();

    // Recorremos los nodos
    for (const node of nodes) {

      // Comprobamos si el nodo está online
      var nodeOnline = Nodes.nodesOnline.find(function (el) {
        return el.id == "cdn-" + node.content_id;
      });

      // Si no está online, lo añadimos
      if (!nodeOnline && node && node.host && node.content_id) {
        Nodes.nodesOnline.push({
          "id": "cdn-" + node.content_id,
          "type": "dynamic-cdn",
          "host": "https://" + node.host + "/",
          "priority": node.priority ? node.priority : 9,
          "secure_token": false,
          "penalty": 0,
          "failover": false,
          "experimental": false,
          "only_ts": false,
          "content_id": parseInt(node.content_id),
          "uris": []
        });
      }

    }

    // Recorremos los nodos online para comprobar si hay que eliminar alguno
    for (var i = 0; i < Nodes.nodesOnline.length; i++) {
      var nodeOnline = Nodes.nodesOnline[i];
      // Si el type no es dynamic-cdn, saltamos
      if (nodeOnline.type != "dynamic-cdn") {
        continue;
      }

      var nodeAvailable = nodes.find(function (el) {
        return el.content_id == nodeOnline.content_id;
      });

      // Si no está disponible, lo eliminamos
      if (!nodeAvailable) {
        Nodes.nodesOnline.splice(i, 1);
      }
    }

  }

  static secureCDN77(url, node, expiryTimestamp = 0) {

    if (!expiryTimestamp) {
      expiryTimestamp = Math.floor(Date.now() / 1000) + 300;
    }

    // Si no tiene / al principio, lo añadimos para generar el hash
    if (url[0] !== "/") {
      url = "/" + url;
    }

    let hash;
    if (node.id == "cdn-121") {
      hash = '/gr1' + url + '4cGwPAoX2tKieoq3';
    } else {
      hash = url + '4cGwPAoX2tKieoq3';
    }

    if (expiryTimestamp) {
      hash = expiryTimestamp + hash;
      expiryTimestamp = "," + expiryTimestamp;
    }

    hash = CryptoJS.MD5(hash).toString(CryptoJS.enc.Hex);
    hash = CryptoJS.enc.Hex.parse(hash);
    hash = CryptoJS.enc.Base64.stringify(hash);

    const finalHash = hash.replace(/\+/g, "-").replace(/\//g, "_");

    // Le quitamos el / del principio a la url porque ya no lo necesita
    url = url.substr(1);

    return node.host + url + '?secure=' + finalHash + expiryTimestamp;
  }

  static secureOVH(url, node, expiryTimestamp = 0) {
    if (!expiryTimestamp) {
      expiryTimestamp = Math.floor(Date.now() / 1000) + 300;
    }

    // Si tiene / al principio, lo quitamos
    if (url[0] === "/") {
      url = url.substr(1);
    }

    var method = 'GET';
    var key = '12345';
    var objectPath = '/v1/AUTH_8549ac1840b448048f7e9d07080dc0e5/gr1/' + url;
    var hmacBody = method + '\n' + expiryTimestamp + '\n' + objectPath;

    // Creamos el hash
    let hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
    hmac.update(hmacBody);
    var sig = CryptoJS.enc.Hex.stringify(hmac.finalize());

    return node.host + url + '?temp_url_sig=' + sig + '&temp_url_expires=' + expiryTimestamp;

  }

  static getURIfromURL(url) {

    // Le quitamos dominio y parámetros por regex
    url = url.replace(/^https?:\/\/[^\/]+/, '');

    // Le quitamos la ruta de OVH
    url = url.replace("/v1/AUTH_8549ac1840b448048f7e9d07080dc0e5/gr1/", "");

    // Le quitamos la ruta de CDN77
    url = url.replace("/gr1/", "");

    var pos = url.indexOf('?');
    if (pos > -1) {
      url = url.substr(0, pos);
    }

    return url;
  }

  static fragmentOk(url, content_id = 0) {

    content_id = parseInt(content_id);
    var uri = Nodes.getURIfromURL(url);

    // Miramos en la url cual de nuestros nodos tiene la uri
    for (let node of Nodes.nodesOnline) {
      // Si el nodo tiene content_id y no coincide, saltamos
      if (node.content_id && node.content_id != content_id) {
        continue;
      }

      // Recorremos las uris del nodo
      for (let nodeuri of node.uris) {
        if (nodeuri == uri) {
          Nodes.decreasePenalty(node.id, 1);
          return;
        }
      }
    }
  }

  static fragmentError(url, content_id = 0) {

    content_id = parseInt(content_id);
    var uri = Nodes.getURIfromURL(url);

    // Miramos en la url cual de nuestros nodos tiene la uri
    for (let node of Nodes.nodesOnline) {
      // Si el nodo tiene content_id y no coincide, saltamos
      if (node.content_id && node.content_id != content_id) {
        continue;
      }

      // Recorremos las uris del nodo
      for (let nodeuri of node.uris) {
        if (nodeuri == uri) {
          Nodes.increasePenalty(node.id, 2);
          return;
        }
      }
    }
  }

}